import { Card, H1, Loading, isSuccess } from "@dgs/core";
import { FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import styled from "styled-components";
import { campaignUrlService } from "../shared/api/campaign_urls/campaignUrlService";

const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Header = styled(H1)`
	font-size: ${({ theme }) => theme.fonts.sizes.large};
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
	color: ${({ theme }) => theme.colors.palette.grey[90]};
`;
const Description = styled.p`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	color: ${({ theme }) => theme.colors.palette.grey[80]};
`;

const StyledCard = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: ${({ theme }) => theme.spacing(15)};
	gap: ${({ theme }) => theme.spacing(6)};
`;

export const JarvisRedirectPage: FC = () => {
	const { t } = useTranslation();
	const { slug = "" } = useParams<"slug">();
	const [isUrlValid, setIsUrlValid] = useState(true);

	const resolveSlug = useCallback(async () => {
		const response = await campaignUrlService.bySlug(slug);

		if (isSuccess(response)) {
			window.location.href = response.data.data.targetUrl;
		} else if (response.status === 404) {
			setIsUrlValid(false);
		}
	}, [slug]);

	useEffect(() => {
		void resolveSlug();
	}, [resolveSlug]);

	return (
		<Container>
			<StyledCard>
				<Header>{isUrlValid ? t("Redirecting...") : t("Error")}</Header>
				{isUrlValid && <Loading />}
				<Description>{isUrlValid ? t("Please wait while we redirect you.") : t("The url is invalid.")}</Description>
			</StyledCard>
		</Container>
	);
};
